import React from 'react'

import { DateOfBirthSelect, Util } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

import { isValidBirthDate } from '../../../util/form-validation'

const { isOlderThan } = Util.validations

export const DateOfBirth = ({ required = true }) => {
  const { getLabel } = useIntl()

  return (
    <DateOfBirthSelect
      label={getLabel('checkout.contact.dateofbirth')}
      errorMessage={getLabel('checkout.contact.dateofbirth.error')}
      dayPlaceholder={getLabel('checkout.contact.dateofbirth.day.placeholder')}
      monthPlaceholder={getLabel('checkout.contact.dateofbirth.month.placeholder')}
      yearPlaceholder={getLabel('checkout.contact.dateofbirth.year.placeholder')}
      validations={[isOlderThan(16), isValidBirthDate]}
      required={required}
    />
  )
}
